<template>
  <div class="frame7">
    <div class="frame7_top_title">
      选择分组 <img src="../../../../public/img/shares_Info/close.png" alt="" />
    </div>
    <div class="frame7_content">
      <div class="frame7_content_options1">
        <div
          class="frame7_content_options1_box1 frame7_content_options1_box3"
        ></div>
        <div class="frame7_content_options1_box2">全部</div>
      </div>
      <div class="frame7_content_options1">
        <div
          class="frame7_content_options1_box1 frame7_content_options1_box3"
        ></div>
        <div class="frame7_content_options1_box2">分组一</div>
      </div>
      <div class="frame7_content_options1">
        <div
          class="frame7_content_options1_box1 frame7_content_options1_box3"
        ></div>
        <div class="frame7_content_options1_box2">分组二</div>
      </div>
      <div class="frame7_content_options1">
        <div
          class="frame7_content_options1_box1 frame7_content_options1_box3"
        ></div>
        <div class="frame7_content_options1_box2">分组三</div>
      </div>
      <div class="frame7_content_options1">
        <div
          class="frame7_content_options1_box1 frame7_content_options1_box3"
        ></div>
        <div class="frame7_content_options1_box2">分组四</div>
      </div>
    </div>
    <div class="frame7_bottom">
      <div class="frame7_bottom_button1">移除自选股</div>
      <div class="frame7_bottom_button2">完成</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.frame7 {
  width: 260px;
  height: 318px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 29px 24px 31px 36px;
  background: #ffffff;
  position: fixed;
  top: calc(50% - 109px);
  left: calc(50% - 130px);
  z-index: 9999999;
}
.frame7_top_title {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  line-height: 20px;
  color: #333333;
  margin-bottom: 30px;
}
.frame7_top_title img {
  width: 15px;
  height: 15px;
  vertical-align: middle;
}
.frame7_content{
    overflow: hidden;
}
.frame7_content_options1 {
  display: flex;
  align-content: center;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
  margin-bottom: 23px;
}
.frame7_content_options1_box1 {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: solid 1px #c1c2cb;
  margin-right: 10px;
}
.frame7_content_options1_box2 {
}
.frame7_bottom {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.frame7_bottom_button1 {
  width: 152px;
  height: 42px;
  border-radius: 6px;
  border: solid 1px #fd4c4c;
  font-size: 16px;
  text-align: center;
  line-height: 42px;
  color: #fd4c4c;
}
.frame7_bottom_button2 {
  width: 84px;
  height: 42px;
  background-color: #fcad2a;
  border-radius: 6px;
  font-size: 16px;
  text-align: center;
  line-height: 42px;
  color: #ffffff;
}
</style>